class HeroCarousel extends HTMLElement {
  constructor() {
    super();

    this.slides = [...this.querySelectorAll(".hero-carousel__slide")];
    this.dots = [...this.querySelectorAll(".hero-carousel__dot")];

    this.prevBtn = this.querySelector(".hero-carousel__arrow--prev");
    this.nextBtn = this.querySelector(".hero-carousel__arrow--next");
    this.viewport = this.querySelector(".hero-carousel__viewport");

    this.currentIndex = 0;

    this.autoplay =
      this.dataset.autoplay === "true";

    this.speed =
      parseInt(this.dataset.speed, 10) || 5000;

    this.timer = null;

    this.observer = null;

    if (this.slides.length <= 1) return;

    this.init();
  }

  init() {

    this.prevBtn?.addEventListener(
      "click",
      () => this.prev()
    );

    this.nextBtn?.addEventListener(
      "click",
      () => this.next()
    );

    this.dots.forEach((dot, index) => {

      dot.addEventListener("click", () => {

        this.go(index);

      });

    });

    this.addEventListener(
      "mouseenter",
      () => this.stopAutoplay()
    );

    this.addEventListener(
      "mouseleave",
      () => this.scheduleNext()
    );

    this.addEventListener(
      "focusin",
      () => this.stopAutoplay()
    );

    this.addEventListener(
      "focusout",
      () => this.scheduleNext()
    );

    this.setupSwipe();

    this.observeVisibility();

    this.activateSlide(0);

    this.scheduleNext();

  }

  next() {

    this.go(this.currentIndex + 1);

  }

  prev() {

    this.go(this.currentIndex - 1);

  }

  go(index) {

    const total = this.slides.length;

    const target =
      (index + total) % total;

    if (target === this.currentIndex) return;

    this.activateSlide(target);

    this.scheduleNext();

  }

  activateSlide(index) {

    this.currentIndex = index;

    this.slides.forEach((slide, i) => {

      slide.classList.toggle(
        "is-active",
        i === index
      );

    });

    this.dots.forEach((dot, i) => {

      dot.classList.toggle(
        "is-active",
        i === index
      );

    });

  }

  scheduleNext() {

    this.stopAutoplay();

    if (!this.autoplay) return;

    if (
      window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches
    ) {
      return;
    }

    this.timer = setTimeout(() => {

      this.next();

    }, this.speed);

  }

  stopAutoplay() {

    if (!this.timer) return;

    clearTimeout(this.timer);

    this.timer = null;

  }

  setupSwipe() {

    let startX = 0;

    let delta = 0;

    const threshold = 50;

    this.viewport.addEventListener(
      "touchstart",
      (e) => {

        startX = e.touches[0].clientX;

      },
      { passive: true }
    );

    this.viewport.addEventListener(
      "touchmove",
      (e) => {

        delta =
          e.touches[0].clientX - startX;

      },
      { passive: true }
    );

    this.viewport.addEventListener(
      "touchend",
      () => {

        if (Math.abs(delta) < threshold) {

          delta = 0;

          return;

        }

        if (delta < 0) {

          this.next();

        } else {

          this.prev();

        }

        delta = 0;

      }
    );

  }

  observeVisibility() {

    if (
      !("IntersectionObserver" in window)
    ) {
      return;
    }

    this.observer =
      new IntersectionObserver(

        ([entry]) => {

          if (entry.isIntersecting) {

            this.scheduleNext();

          } else {

            this.stopAutoplay();

          }

        },

        {
          threshold: 0.35
        }

      );

    this.observer.observe(this);

  }

  disconnectedCallback() {

    this.stopAutoplay();

    this.observer?.disconnect();

  }

}

customElements.define(
  "hero-carousel",
  HeroCarousel
);